/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overflow-x[_ngcontent-%COMP%] {\n    overflow-x: scroll;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/bi/biAdminStyles.css.shim.ngstyle.js.pre-build-optimizer.js